<div class="slider">
    <nav id="slider-menu">
        <div class="sidebar">
            <div class="sidebar-main">
                <div class="mobile-section">NAVIGATION</div>
                <a class="link" (click)="onLinkClick()" [routerLink]="loginLink" [routerLinkActive]="['active']">
                    <div class="arrow">
                        <div class="label">Login</div>
                    </div>
                </a>
                <a class="link" (click)="onLinkClick()" [routerLink]="registerLink" [routerLinkActive]="['active']">
                    <div class="arrow">
                        <div class="label">Sign up</div>
                    </div>
                </a>
            </div>
            <div>
                <div class="people_with_books">
                    <img src="../../../assets/img/cover.jpg" width="250px" />
                </div>
                <div class="sidebar-bottom"></div>
            </div>
        </div>
    </nav>
</div>
